<template>
  <el-container class="father">
    <el-header class="layout-header">
      <!-- 顶部蓝色导航栏 -->
      <div class="header-top">
        <div class="header-left">
          <img src="/fonts/logo96320.png" alt />
          <span class="title">湖南省96320转运车管理系统</span>
        </div>
        <div class="header-center">
          <div class="home" v-if="home.length!==0" @click="$router.push(home[0].menuUrl)">
            <img src="../../fonts/home@2x.png" alt />
            <span>首页</span>
          </div>
          <div class="operation" v-if="operation.length!==0" @click="$router.push(operation[0].menuUrl)">
            <img src="../../fonts/operation@2x.png" alt />
            <span>运营管理</span>
          </div>
          <div class="setting" v-if="system.length!==0" @click="$router.push(system[0].menuUrl)">
            <img src="../../fonts/settings@2x.png" alt />
            <span>业务管理</span>
          </div>
        </div>
        <div class="header-right">
          <img src="../../fonts/user@2x.png" alt />
          <span class="welcome">欢迎&nbsp;{{ userName }}</span>
          <span @click="editUserTap()" class="exit">修改密码</span>
          <span @click="exit()" class="exit">退出登录</span>
        </div>
      </div>

      <!-- 面包屑 + 标签页 + 大屏按钮 区域 -->
      <div class="header-under">
        <el-breadcrumb separator="|" class="breadcrumb-box">
          <el-breadcrumb-item>
            <span @click="statusEliminate($route.meta.bread.title)">{{ $route.meta.bread.title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.meta.bread.children">
            {{ $route.meta.bread.children.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="tags-view-wrapper">
          <TagsView class="tags-view-inline" />
        </div>

        <el-button v-if="largeScreen.length!==0" type="warning" class="header-under-btn" @click="toBigscreen">
          <span>大屏</span>
        </el-button>
      </div>
    </el-header>

    <el-container class="main">
      <router-view />
    </el-container>

    <el-footer>
      <div class="footer">湖南96320服务平台 Copyright 2013-2026 ©版权所有 湘ICP备2020023409号-1</div>
    </el-footer>

    <!-- ========== 修改密码弹窗（重做） ========== -->
    <el-dialog
      :visible.sync="editUserFormVisible"
      custom-class="edit-dialog"
      width="520px"
      :close-on-click-modal="false"
      center>
      <div slot="title" class="dialog-title">修改用户密码</div>
      <el-form
        :model="editUserForm"
        ref="editForms"
        :rules="editRules"
        label-width="100px"
        class="edit-form">
        <el-form-item label="用户名">
          <el-input v-model="editUserForm.userName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="editUserForm.mobilePhone" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="passWord1" label="新密码">
          <el-input type="password" v-model="editUserForm.passWord1" autocomplete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item prop="passWord2" label="确认新密码">
          <el-input type="password" v-model="editUserForm.passWord2" autocomplete="off" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserPassWd('editForms')">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { handleSpeak, IsPhone } from '@/utils/speechSynthesis.js'
import TagsView from '@/components/TagsView/index.vue'

var validatePass = (rule, value, callback) => {
  var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{9,16}')
  if (value === '') {
    callback(new Error('请输入密码'))
  } else if (value.length < 8) {
    callback(new Error('密码最少8位'))
  } else if (!regex.test(value)) {
    callback(new Error('密码必须同时包含字母、数字和特殊字符其中三项且至少8位'))
  } else {
    callback()
  }
}
export default {
  name: 'Layout',
  components: {
    TagsView
  },
  data () {
    return {
      disabled: true,
      editUserFormVisible: false,
      userName: sessionStorage.getItem('userName') || '未登录',
      title: '首页',
      nav: [],
      home: '',
      operation: '',
      system: '',
      largeScreen: '',
      editUserForm: {
        userName: '', mobilePhone: '', passWord: '', passWord1: '', passWord2: ''
      },
      editRules: {
        passWord1: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        passWord2: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      objData: '',
      tipToast: false,
      ws: '',
      timer: ''
    }
  },
  created () {
    this.getNav()
  },
  mounted () {
    console.log(this.ws, 'this.ws')
    this.init()
  },
  beforeDestroy () {
    if (this.ws) {
      this.ws.close()
    }
    clearInterval(this.timer)
  },
  methods: {
    editUserTap () {
      this.editUserForm.userName = sessionStorage.getItem('userName')
      this.editUserForm.mobilePhone = sessionStorage.getItem('phone')
      // this.editUserForm.passWord = sessionStorage.getItem('passwd')
      this.editUserFormVisible = true
    },
    async editUserPassWd (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.editUserForm.passWord1 != this.editUserForm.passWord2 && this.editUserForm.passWord1) {
            this.$message.error('两次密码输入不一致，请重新输入！')
            return false
          }
          const { data: res } = await this.$http.post('userManageServer/user/updateUserPassWord', {
            userName: this.editUserForm.userName,
            mobilePhone: this.editUserForm.mobilePhone,
            passWord: this.editUserForm.passWord1
          })
          if (res.statusCode !== '200') return this.$message.error('修改密码失败')
          this.editUserFormVisible = false
          this.$message.success('修改密码成功,请重新登录')
          setTimeout(() => {
            this.exit()
          }, 2000)
        } else {
          return false
        }
      })
    },
    statusEliminate (str) {
      if (str == '运营管理') {
        this.$route.path != '/operation' ? this.$router.push('/operation') : ''
      } else if (str == '系统管理') {
        this.$route.path != '/system' ? this.$router.push('/system') : ''
      } else if (str == '首页') {
        this.$route.path != '/home' ? this.$router.push('/home') : ''
      }
    },
    toBigscreen () {
      this.$router.push('/bigScreen')
    },
    exit () {
      this.$confirm('确定退出登录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear()
        this.$store.dispatch('CLEAR')
        this.$router.push('/login')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });
    },
    getNav () {
      this.nav = JSON.parse(sessionStorage.getItem('headerNav'))
      if (this.nav instanceof Array) {
        this.home = this.nav.filter(function (item) {
          return item.menuUrl === '/home'
        })
        this.operation = this.nav.filter(function (item) {
          return item.menuUrl === '/operation'
        })
        this.system = this.nav.filter(function (item) {
          return item.menuUrl === '/system'
        })
        this.largeScreen = this.nav.filter(function (item) {
          return item.menuUrl === '/bigScreen'
        })
      }
      sessionStorage.setItem('menuList', JSON.stringify(this.system[0].twoMenusList))
    },
    init () {
      const userId = sessionStorage.getItem('userId')
      if ('WebSocket' in window) {
        this.ws = new WebSocket(process.env.VUE_APP_WS_API + 'pmService/myWs?userId=' + userId)
        this.ws.onopen = this.open
        this.ws.onerror = this.error
        this.ws.onmessage = this.getMessage
        this.ws.onclose = this.close
      } else {
        alert('当前浏览器 Not support websocket')
      }
    },
    open: function () {
      console.log('ws调用连接成功回调方法')
      this.timer = window.setInterval(() => {
        var ping = { type: 'pingpong' }
        this.ws.send(JSON.stringify(ping))
      }, 50000)
    },
    error: function () {
      console.log('WebSocket连接发生错误')
    },
    getMessage (msg) {
      if (msg.data) {
        if (typeof msg.data === 'string') {
          console.log('收到信息:' + msg.data)
          if (msg.data.includes('pingpong')) {
            return false
          }
          const str = JSON.parse(msg.data)
          this.objData = str
          this.tipToast = true
          if (!IsPhone()) {
            handleSpeak(str.title)
          }
          const route = this.$route.path
          if (route === '/operation/dispatch/orderScheduling' || route === '/system/hospitalManagement/Information') {
            if (route === '/system/hospitalManagement/Information') {
              this.$eventBus.$emit('message')
            } else {
              this.$eventBus.$emit('messageOder')
            }
          }
        }
      }
    },
    close: function (e) {
      console.log(e, 'socket已经关闭')
      clearInterval(this.timer)
    },
    playSound () {
      var url = 'http://img.i12320.com/newOrder.mp3'
      var n = new Audio(url)
      n.src = url
      n.play()
    },
    pagenew () {
      if (this.objData.category == 1) {
        this.$router.push('/operation/dispatch/orderScheduling')
      } else {
        this.$router.push('/system/hospitalManagement/Information')
      }
      this.tipToast = false
    }
  }
}
</script>

<style lang="less" scoped>
/* ===== 基础布局 ===== */
.father {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: #fff;

  .layout-header {
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto;
  }

  .main {
    margin-top: 140px !important;
    padding: 0 !important;
    width: 100% !important;
    height: calc(100vh - 180px) !important;
    overflow: auto !important;
    background: #fff;
  }

  .el-footer {
    padding: 0;
    height: 40px !important;
    line-height: 40px;
    text-align: center;
    background: #f5f5f5;
    font-size: 12px;
    color: #888;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #e8e8e8;
  }
}

/* ===== 顶部蓝色导航栏 ===== */
.header-top {
  height: 80px;
  background: url('../../fonts/top_bar_bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  color: #fff;
  padding: 0 24px;
  box-sizing: border-box;

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      height: 40px;
      width: auto;
    }

    .title {
      font-size: 19px;
      font-weight: 600;
      letter-spacing: 0.5px;
      white-space: nowrap;
    }
  }

  .header-center {
    flex: 1;
    display: flex;
    margin-left: 80px;
    gap: 28px;

    > div {
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      padding: 6px 12px;
      border-radius: 6px;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.12);
      }

      img {
        height: 18px;
        width: auto;
      }

      span {
        font-size: 17px;
        font-weight: 500;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 15px;

    img {
      height: 18px;
      width: auto;
      opacity: 0.9;
    }

    .welcome {
      font-weight: 500;
    }

    .exit {
      cursor: pointer;
      padding: 4px 12px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      transition: background 0.2s;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 0.25);
      }
    }
  }
}

/* ===== 面包屑 + 标签页 + 大屏按钮 ===== */
.header-under {
  height: 60px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  gap: 16px;
  width: 100%;

  .breadcrumb-box {
    flex-shrink: 0;
    font-size: 13px;
    padding: 4px 0;

    .el-breadcrumb__item {
      color: #909399;
      font-weight: 500;
	  font-size: 16px;

      span {
        cursor: pointer;
        transition: color 0.2s;

        &:hover {
          color: #1a3a6b;
        }
      }

      &:last-child {
        color: #1a3a6b;
        font-weight: 600;
      }
    }
  }

  .tags-view-wrapper {
    flex: 1;
    max-width: calc(100% - 320px);
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .tags-view-inline {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .header-under-btn {
    flex-shrink: 0;
    font-size: 15px;
    height: 34px;
    padding: 0 20px;
    border-radius: 4px;
    background: #e6a23c;
    border-color: #e6a23c;
    color: #fff;
    font-weight: 500;
    letter-spacing: 1px;

    &:hover {
      background: #ebb563;
      border-color: #ebb563;
    }

    span {
      color: #fff;
    }
  }
}

/* ===== 修改密码弹窗 ===== */
::v-deep .edit-dialog {
  border-radius: 8px;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 24px;
    background: #1a3a6b;
    border-bottom: none;

    .dialog-title {
      color: #fff;
      font-size: 17px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn {
      top: 18px;
      right: 20px;

      .el-dialog__close {
        color: rgba(255, 255, 255, 0.85);
        font-size: 18px;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 30px 40px 10px;
    background: #fff;
  }

  .el-dialog__footer {
    padding: 10px 40px 24px;
    background: #fff;
    text-align: right;
    border-top: none;
  }
}

/* 表单样式 */
.edit-form {
  .el-form-item {
    margin-bottom: 22px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ::v-deep .el-form-item__label {
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
    padding-right: 12px;
  }

  ::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    transition: border-color 0.2s;

    &:focus {
      border-color: #1a3a6b;
    }

    &[disabled] {
      background: #f5f7fa;
      color: #909399;
    }
  }

  ::v-deep .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c;
  }

  ::v-deep .el-form-item__error {
    font-size: 12px;
    padding-top: 4px;
  }
}

/* 弹窗底部按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    height: 38px;
    padding: 0 24px;
    border-radius: 4px;
    font-size: 14px;
    letter-spacing: 1px;
  }

  .el-button--primary {
    background: #1a3a6b;
    border-color: #1a3a6b;

    &:hover {
      background: #2a4a7b;
      border-color: #2a4a7b;
    }
  }
}

/* ===== 响应式微调 ===== */
@media screen and (max-width: 1400px) {
  .header-top {
    padding: 0 16px;

    .header-left .title {
      font-size: 16px;
    }

    .header-center {
      margin-left: 40px;
      gap: 18px;

      > div span {
        font-size: 15px;
      }
    }

    .header-right {
      font-size: 13px;
      gap: 10px;
    }
  }

  .header-under {
    padding: 0 16px;

    .tags-view-wrapper {
      max-width: calc(100% - 260px);
    }
  }
}

@media screen and (max-width: 1100px) {
  .header-top {
    .header-left .title {
      font-size: 14px;
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .header-center {
      margin-left: 16px;
      gap: 10px;

      > div span {
        font-size: 13px;
      }

      > div img {
        height: 15px;
      }
    }

    .header-right .welcome {
      display: none;
    }
  }

  .header-under {
    .breadcrumb-box {
      display: none;
    }

    .tags-view-wrapper {
      max-width: calc(100% - 110px);
    }
  }
}
</style>